var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGender({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4556 17.0389V23.2348M13.1663 20.1368H7.74487M20.9112 5.42147V1.54901M20.9112 1.54901H17.0388M20.9112 1.54901L16.2294 6.23082",
    stroke: "#5C5CAB",
    strokeOpacity: 0.6,
    strokeWidth: 1.54899,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4557 16.2644C14.0915 16.2644 17.0389 13.317 17.0389 9.68121C17.0389 6.04542 14.0915 3.09802 10.4557 3.09802C6.81995 3.09802 3.87256 6.04542 3.87256 9.68121C3.87256 13.317 6.81995 16.2644 10.4557 16.2644Z",
    stroke: "#5C5CAB",
    strokeOpacity: 0.6,
    strokeWidth: 1.54899,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7838,
    height: 24.7838,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.aac99e2d1a772cfa8e1e8cd564ed2121.svg";
export { ForwardRef as ReactComponent };